import React from 'react';
import { Link } from 'react-router-dom';
import './BioPage.css';

export default function DirectorKaitlyn() {
  return (
    <main className="bioContainer">
      <h1>Kaitlyn Lowery — Director of Educational Services  </h1>

      {/* Hero card with a larger portrait */}
      <section className="bioCard bioCardHero">
        <img
          src="/images/kaitlyn.png"  // same image as the About page
          alt="Kaitlyn Lowery"
          className="bioAvatarLarge"
          width="1200"
          height="1200"
          loading="eager"
          sizes="(max-width: 900px) 60vw, 340px"
        />

        <div className="bioHeader">
          <h2>Curriculum that’s welcoming, playful, and rigorous</h2>
          <p className="bioSubtitle"></p>
          <div className="bioBody">
            <p>
              Ms. Lowery oversees curriculum and instructional quality at ChronoTech Robotics.
              She designs age-appropriate lessons that blend creativity with core STEM skills, and
              coaches instructors to deliver engaging, inclusive sessions for every learner.
            </p>
            <p>
              Her work centers on clear learning outcomes, joyful practice, and scaffolding that helps
              students grow from first builds to advanced, project-based challenges.
            </p>

            <ul className="bioList">
              <li><strong>Focus:</strong> curriculum, teacher training, learning outcomes</li>
              <li><strong>Tracks:</strong> Beginner → Intermediate → Advanced robotics</li>
              <li><strong>Goal:</strong> equitable access to hands-on STEM for all students</li>
            </ul>

          <div className="bioActions">
  <Link className="bioBackLink secondary" to="/about">← Back to About</Link>
  <Link className="bioBackLink" to="/robokidslanding">See Classes</Link>
</div>

          </div>
        </div>
      </section>

      {/* Longer narrative section */}
      <section className="bioLong">
        <h3>Kaitlyn’s Approach</h3>
        <p>
          Ms. Lowery builds learning experiences that meet students where they are and then stretch them
          with just-right challenges. Lessons combine quick wins, collaborative problem-solving, and
          reflective checkpoints so kids see themselves as capable engineers.
        </p>

        <h3>Experience & Classroom Lens</h3>
        <p>
          With a background in child-centered pedagogy and inclusive classrooms, Kaitlyn brings a
          practical lens to every activity: clear instructions, visual scaffolds, and flexible extensions
          for students who want to go deeper.
        </p>

        <h3>What Families Can Expect</h3>
        <ul>
          <li>Friendly pacing with visible progress every session</li>
          <li>Emphasis on safety, curiosity, and creative iteration</li>
          <li>Options to personalize builds and celebrate student voice</li>
        </ul>
      </section>
    </main>
  );
}
